(() => {
  'use strict';
  if (window.DACWishlistUI) return;
  const configNode = document.getElementById('dac-wishlist-ui-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const t = config.words;
  const normalize = value => String(value || '').trim().replace(/\s+/g, ' ').normalize('NFC');
  const key = item => String(item.empi) + ':' + String(item.epi);
  const member = (list, item) => (list.listcontents || []).some(value => key(value) === key(item));
  let active, generation = 0, toast, toastTimer, root, serial = 0;
  const sharedPasses = new WeakMap();
  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function copyIcon(id) { return document.getElementById(id)?.content.cloneNode(true) || document.createDocumentFragment(); }
  function host() {
    if (root?.isConnected) return root;
    let plugin = document.getElementById('swym-plugin');
    if (!plugin) { plugin = el('div'); plugin.id = 'swym-plugin'; document.body.append(plugin); }
    root = plugin.querySelector('[data-dac-native-wishlist-ui]');
    if (!root) {
      root = el('div', 'swym-ui-component swym-modals-container'); root.dataset.dacNativeWishlistUi = '';
      plugin.append(root);
    }
    return root;
  }
  function safeURL(value, image = false) {
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      if (image) {
        if (!/(^|\.)shopify\.com$|(^|\.)diamondartclub\.com$/.test(url.hostname)) return '';
      } else if (!['diamondartclub.com','www.diamondartclub.com','diamond-art-club.myshopify.com'].includes(url.hostname) || !/\/products\/[^/]+/.test(url.pathname)) return '';
      return url.href;
    } catch (_) { return ''; }
  }
  function image(value, className) {
    const src = safeURL(value, true);
    if (!src) return null;
    const node = el('img', className); node.src = src; node.alt = ''; node.width = 68; node.height = 76;
    node.addEventListener('error', () => node.remove(), {once:true});
    return node;
  }
  function closeButton(close) {
    const button = el('button', 'swym-close-btn dac-close-control'); button.type = 'button';
    button.setAttribute('aria-label', t.close); button.append(copyIcon('dac-wishlist-close-icon'));
    button.addEventListener('click', close); return button;
  }
  function assertCurrent(state) {
    if (active !== state || generation !== state.generation || !state.dialog.isConnected) throw new Error('changed');
  }
  function dismiss(state, restore = true) {
    if (!state || state.closed) return;
    state.closed = true;
    if (active === state) active = null;
    state.dialog.close(); state.dialog.remove();
    if (!document.querySelector('.dac-native-wishlist-dialog[open]')) {
      document.body.classList.remove('swym-modal-active');
      document.body.style.overflow = state.previousOverflow;
    }
    if (restore && state.opener?.isConnected) state.opener.focus({preventScroll:true});
  }
  function status(state, text, error = false) {
    state.status.textContent = text;
    state.status.setAttribute('role', error ? 'alert' : 'status');
  }
  function currentProduct(value, opener) {
    const variant = value?.epi || opener?.dataset.variantId || window.SwymProductInfo?.currentVariant;
    const page = window.SwymProductVariants?.[variant] || window.SwymPageData || {};
    const product = {...page, ...value, epi:variant};
    if (!/^\d+$/.test(String(product.empi)) || !/^\d+$/.test(String(product.epi))) throw new Error('product');
    product.du = safeURL(product.du); if (!product.du) throw new Error('product');
    const card = opener?.closest('article');
    product.dt = normalize(product.dt || card?.querySelector('.product-card-container-content-title,h3')?.textContent || window.SwymProductInfo?.product?.title);
    product.vendor = normalize(product.vendor || card?.querySelector('.product-card-container-content-vendor')?.textContent || window.SwymProductInfo?.product?.vendor);
    product.iu = safeURL(product.iu || card?.querySelector('figure img,img')?.currentSrc || card?.querySelector('img')?.src, true);
    return product;
  }
  function addNewList(state) {
    if (state.busy || state.newRows.length >= 20) return;
    state.userSelected = true;
    const row = el('div', 'swym-new-wishlist-item swym-selected');
    const wrap = el('div', 'swym-new-wishlist-input-container');
    const input = el('input', 'swym-new-wishlist-name'); input.type = 'text'; input.id = 'dac-native-wishlist-name-' + (++serial);
    input.minLength = 3; input.maxLength = 50; input.autocomplete = 'off'; input.placeholder = t.namePlaceholder; input.required = true;
    const label = el('label', 'dac-wishlist-name-label', t.nameLabel); label.htmlFor = input.id;
    const error = el('span', 'error-msg'); error.id = input.id + '-error'; error.setAttribute('role', 'alert');
    input.setAttribute('aria-describedby', error.id);
    error.textContent = t.nameError;
    input.addEventListener('input', () => {
      const names = state.lists.map(list => normalize(list.lname).toLocaleLowerCase());
      let valid = true;
      for (const field of state.newRows) {
        const name = normalize(field.input.value), lower = name.toLocaleLowerCase();
        const message = name.length < 3 || name.length > 50 ? t.nameError : names.includes(lower) ? t.duplicate : '';
        names.push(lower); field.error.textContent = message;
        field.row.classList.toggle('swym-input-has-error', Boolean(message));
        field.input.setAttribute('aria-invalid', String(Boolean(message))); valid = valid && !message;
      }
      state.save.disabled = !valid;
    });
    wrap.append(label, input, error); row.append(wrap); state.items.append(row);
    state.newRows.push({row,input,error}); state.save.disabled = true; input.focus();
  }
  function updateSave(state) {
    if(state.closed||state.busy||state.failed)return;
    if(state.newRows.some(({input,error})=>!input.value.trim()||input.value.trim().length<3||input.value.trim().length>50||error.textContent)){state.save.disabled=true;return;}
    state.save.disabled=!state.newRows.length&&!state.items.querySelector('.swym-wishlist-item[aria-checked="true"]')&&!state.lists.some(list=>member(list,state.product)&&state.rows.get(String(list.lid))?.button.getAttribute('aria-checked')==='false');
  }
  function finishMemberships(state) {
    if(state.closed||state.busy||state.userSelected||[...state.rows.values()].some(row=>row.loading))return;
    if([...state.rows.values()].every(row=>row.ready)&&!state.lists.some(list=>member(list,state.product))){
      const first=[...state.rows.values()].find(row=>row.ready);
      if(first){first.button.setAttribute('aria-checked','true');first.button.classList.add('swym-selected');}
    }
    updateSave(state);
  }
  async function loadMembership(state,lid,resultTask) {
    const row=state.rows.get(lid);
    if(!row||state.closed||state.busy||row.task)return row?.task;
    row.loading=true;row.button.disabled=true;row.button.setAttribute('aria-busy','true');row.retry.hidden=true;row.count.textContent=t.loading;
    row.task=(async()=>{
      try{
        const data=await (resultTask||window.DACWishlist.details(lid));assertCurrent(state);
        if(state.busy)return;
        if(String(data?.list?.lid)!==lid||!Array.isArray(data.items))throw new Error('lists');
        const list={...data.list,listcontents:data.items},index=state.lists.findIndex(value=>String(value.lid)===lid);
        if(index<0)throw new Error('changed');
        state.lists[index]=list;row.ready=true;row.button.disabled=false;
        const selected=member(list,state.product);row.button.setAttribute('aria-checked',String(selected));row.button.classList.toggle('swym-selected',selected);
        row.name.textContent=normalize(list.lname);row.count.textContent=data.items.length+' '+(data.items.length===1?t.item:t.items);
      }catch(_){
        if(state.closed||state.busy)return;
        row.ready=false;row.button.disabled=true;row.count.textContent=t.loadError;row.retry.hidden=false;
      }finally{
        row.loading=false;row.task=null;row.button.removeAttribute('aria-busy');finishMemberships(state);updateSave(state);
      }
    })();
    return row.task;
  }
  function loadMemberships(state) {
    if(state.membershipTask)return state.membershipTask;
    const task=(async()=>{
      while(state.membershipQueue.length&&!state.closed&&!state.busy){
        const lids=state.membershipQueue.splice(0,4),api=window.DACWishlist;
        const batch=api.detailsBatch?api.detailsBatch(lids):null;
        await Promise.all(lids.map(lid=>loadMembership(state,lid,batch?batch.then(rows=>{
          const row=rows.find(value=>value.lid===lid);
          if(!row||row.error)throw new Error(row?.error||'lists');return row;
        }):null)));
      }
    })();
    state.membershipTask=task;task.finally(()=>{if(state.membershipTask===task)state.membershipTask=null;}).catch(()=>{});return task;
  }
  function retryMembership(state,lid){
    if(state.closed||state.busy||state.rows.get(lid)?.loading)return;
    state.rows.get(lid).loading=true;state.membershipQueue.unshift(lid);loadMemberships(state);
  }
  function renderLists(state, lists, progressive=false) {
    const summaries=lists.filter(list => list.lid && (!list.lty || list.lty === 'wl'));
    state.lists = summaries.map(list=>progressive?{...list,listcontents:[]}:list);
    state.rows=new Map();state.userSelected=false;state.failed=false;
    state.items.replaceChildren(); state.newRows = [];
    const hasMember = state.lists.some(list => member(list, state.product));
    state.lists.forEach((list, index) => {
      const summary=summaries[index];
      const row = el('button', 'swym-wishlist-item swym-is-button'); row.type = 'button'; row.dataset.lid = String(list.lid); row.setAttribute('role', 'checkbox');
      const selected = !progressive&&(member(list, state.product) || (!hasMember && index === 0));
      row.classList.toggle('swym-selected', selected); row.setAttribute('aria-checked', String(selected));
      const preview = el('span', 'swym-wishlist-image');
      const art = image(summary.listcontents?.[0]?.iu);
      preview.append(art || copyIcon('dac-wishlist-empty-icon'));
      const copy = el('span', 'dac-wishlist-row-copy');
      const count = Number.isInteger(list.cnt) ? list.cnt : list.listcontents?.length || 0;
      const name=el('span','swym-wishlist-name',normalize(list.lname)),countNode=el('span','swym-wishlist-count',progressive?t.loading:count+' '+(count===1?t.item:t.items));
      copy.append(name,countNode);
      const check = el('span', 'swym-icon'); check.setAttribute('aria-hidden','true'); row.append(preview,copy,check);
      row.addEventListener('click', () => {
        if (state.busy) return;
        state.userSelected=true;
        const next = row.getAttribute('aria-checked') !== 'true'; row.setAttribute('aria-checked',String(next)); row.classList.toggle('swym-selected',next);
        updateSave(state);
      });
      const retry=el('button','dac-native-wishlist-list-retry',t.retry);retry.type='button';retry.hidden=true;retry.setAttribute('aria-label',t.retry+' '+normalize(list.lname));
      retry.addEventListener('click',()=>retryMembership(state,String(list.lid)));
      const wrapper=el('div','dac-native-wishlist-row');wrapper.append(row,retry);state.items.append(wrapper);
      row.disabled=progressive;
      state.rows.set(String(list.lid),{button:row,name,count:countNode,retry,ready:!progressive,loading:progressive,task:null});
    });
    status(state, ''); state.save.disabled = progressive; state.create.disabled = false;
    if (!state.lists.length) addNewList(state);
    if(progressive){state.membershipQueue=[...state.rows.keys()];loadMemberships(state);}
  }
  function validateNewLists(state) {
    const names = new Set(state.lists.map(list => normalize(list.lname).toLocaleLowerCase()));
    let invalid;
    const values = state.newRows.map(({row,input,error}) => {
      const lname = normalize(input.value), lower = lname.toLocaleLowerCase();
      const message = lname.length < 3 || lname.length > 50 ? t.nameError : names.has(lower) ? t.duplicate : '';
      if (message) { error.textContent = message; row.classList.add('swym-input-has-error'); input.setAttribute('aria-invalid','true'); invalid ||= input; }
      names.add(lower); return {lname};
    });
    if (invalid) { invalid.focus(); throw new Error('validation'); }
    return values;
  }
  async function savePicker(state) {
    if (state.busy || state.failed) return;
    let names;
    try { names = validateNewLists(state); } catch (_) { return; }
    const selected = new Set([...state.items.querySelectorAll('.swym-wishlist-item[aria-checked="true"]')].map(row => row.dataset.lid));
    const removals = state.lists.filter(list => member(list,state.product) && !selected.has(String(list.lid)));
    if (!selected.size && !names.length && !removals.length) { status(state,t.select,true); return; }
    if (removals.length && !window.DACListUndo?.scheduleBatch) { status(state,t.saveError,true); return; }
    state.busy = true; state.save.disabled = true; state.create.disabled = true; state.dialog.setAttribute('aria-busy','true');
    queueMicrotask(() => { if (state.busy || state.failed) state.save.disabled = true; });
    state.items.querySelectorAll('button,input').forEach(node => { node.disabled = true; });
    let creating = false;
    try {
      assertCurrent(state);
      const api = window.DACWishlist;
      await state.membershipTask;assertCurrent(state);
      let additions = state.lists.filter(list => selected.has(String(list.lid)) && !member(list,state.product));
      const changedLists=[...additions,...removals];
      const fresh = await (api.summaryLists?api.summaryLists({fresh:true}):api.lists()); assertCurrent(state);
      if (changedLists.some(list => !fresh.some(now => String(now.lid) === String(list.lid) && normalize(now.lname) === normalize(list.lname)))) throw new Error('changed');
      if(api.summaryLists&&api.details){
        for(let offset=0;offset<changedLists.length;offset+=4){
          const batch=changedLists.slice(offset,offset+4),rows=api.detailsBatch?await api.detailsBatch(batch.map(list=>String(list.lid))):await Promise.all(batch.map(list=>api.details(String(list.lid))));assertCurrent(state);
          for(let index=0;index<batch.length;index++){
            const list=batch[index],now=api.detailsBatch?rows.find(row=>row.lid===String(list.lid)):rows[index];
            if(!now||now.error||String(now.list?.lid)!==String(list.lid)||!Array.isArray(now.items))throw new Error('changed');
            if(normalize(now.list?.lname)!==normalize(list.lname)||member({...now.list,listcontents:now.items},state.product)!==member(list,state.product))throw new Error('changed');
          }
        }
      }else if(changedLists.some(list=>!fresh.some(now=>String(now.lid)===String(list.lid)&&member(now,state.product)===member(list,state.product))))throw new Error('changed');
      if (names.length) {
        if (names.some(def => fresh.some(list => normalize(list.lname).toLocaleLowerCase() === def.lname.toLocaleLowerCase()))) throw new Error('duplicate');
        creating = true;
        const created = await api.mutate('/lists/create-multiple', {lists:names});
        assertCurrent(state);
        const rows = Array.isArray(created) ? created : created?.lists;
        if (!Array.isArray(rows) || rows.length !== names.length || rows.some(list => !list.lid)) throw new Error('uncertain');
        additions.push(...rows); creating = false;
      }
      for (const list of additions) {
        assertCurrent(state);
        await api.mutate('/lists/update-ctx', {lid:String(list.lid),a:[state.product]});
      }
      assertCurrent(state);
      if (removals.length) window.DACListUndo.scheduleBatch(removals.map(list => ({kind:'wishlist',lid:String(list.lid),item:{epi:state.product.epi,empi:state.product.empi,du:state.product.du},title:state.product.dt,listName:list.lname})));
      confirmSaved(state.dialog);
      dismiss(state);
      if (additions.length) notify({product:state.product,type:'added'});
      document.dispatchEvent(new CustomEvent('dac:wishlist-picker-saved', {detail:{product:state.product}}));
    } catch (error) {
      if (state.closed) return;
      state.failed = true;
      status(state, creating || error.message === 'uncertain' ? t.uncertain : error.message === 'changed' ? t.changed : error.message === 'duplicate' ? t.duplicate : t.saveError, true);
    } finally {
      state.busy = false; state.dialog.removeAttribute('aria-busy');
    }
  }
  async function openPicker(value, opener = document.activeElement, onSaved) {
    if (active) dismiss(active,false);
    clearToast();
    let product;
    try { product = currentProduct(value,opener); } catch (_) { notify({type:'error',message:t.saveError}); return; }
    const dialog = el('dialog', 'dac-native-wishlist-dialog swym-modal swym-add-wishlist-modal');
    dialog.dataset.dacProductId = String(product.empi); dialog.dataset.dacVariantId = String(product.epi);
    const content = el('div', 'swym-modal-content');
    const title = el('div','swym-product-title');
    const art = image(product.iu); if (art) { const frame = el('div','swym-product-image'); frame.append(art); title.append(frame); }
    const heading = el('h2','dac-swym-heading'); heading.id = 'dac-native-wishlist-title'; heading.append(el('span','dac-swym-name',product.dt || t.picker));
    if (product.vendor) heading.append(el('span','swym-product-vendor',product.vendor)); title.append(heading);
    dialog.setAttribute('aria-labelledby',heading.id);
    const items = el('div','swym-wishlist-items'); const label = el('p','swym-wishlist-items-title',t.picker);
    const message = el('p','dac-native-wishlist-status',t.loading); message.setAttribute('role','status');
    const actions = el('div','swym-action-btns'); const create = el('button','swym-new-wishlist-btn',t.create), save = el('button','swym-add-to-list-btn',t.save);
    create.type = save.type = 'button'; create.disabled = save.disabled = true; actions.append(create,save);
    const state = {dialog,opener,product,onSaved,items,status:message,save,create,newRows:[],lists:[],generation,previousOverflow:document.body.style.overflow}; active = state;
    const close = () => dismiss(state);
    content.append(closeButton(close),title,label,items,message,actions); dialog.append(content); host().append(dialog);
    dialog.addEventListener('cancel', event => {event.preventDefault();close();});
    dialog.addEventListener('click',event=>{if(event.target===dialog)close();});
    dialog.addEventListener('close',()=>dismiss(state));
    create.addEventListener('click',()=>addNewList(state));
    save.addEventListener('click',event=>{if(!event.defaultPrevented)savePicker(state);});
    document.body.classList.add('swym-modal-active'); document.body.style.overflow='hidden'; dialog.showModal();
    const load = async () => {
      try {
        state.retry?.remove(); status(state,t.loading); await window.DACWishlist.ready;
        const api=window.DACWishlist,progressive=typeof api.summaryLists==='function'&&typeof api.details==='function';
        const lists = await (progressive?api.summaryLists():api.lists()); assertCurrent(state);
        if (!Array.isArray(lists)) throw new Error('lists'); renderLists(state,lists,progressive);
      } catch (_) {
        if (state.closed) return;
        status(state,t.loadError,true);
        state.retry = el('button','dac-native-wishlist-retry',t.retry); state.retry.type='button';
        state.retry.addEventListener('click',load,{once:true}); message.after(state.retry);
      }
    };
    await load(); return dialog;
  }
  function confirmSaved(dialog) {
    if (!active || active.dialog !== dialog || active.saved) return;
    active.saved = true;
    try { active.onSaved?.(active.product); } catch (_) {}
  }
  function clearToast() { clearTimeout(toastTimer); toast?.remove(); toast = null; }
  function notify(data = {}) {
    clearToast();
    const product = data.product || data;
    const message = data.message || ({added:t.added,removed:t.removed,updated:t.updated,error:t.saveError}[data.type] || t.added);
    toast = el('div','dac-native-wishlist-toast-host');
    const card = el('div','dac-wishlist-confirmation swym-notification-wishlist'); const tile = el('div','swym-product-tile');
    const art = image(product.iu,'swym-image'); if (art) tile.append(art);
    const copy = el('div','dac-wishlist-copy'); copy.append(el('p','dac-wishlist-status',message));
    if (product.dt) copy.append(el('p','dac-wishlist-kit-name',normalize(product.dt))); tile.append(copy,closeButton(clearToast)); card.append(tile);
    const url = new URL(config.wishlistUrl,location.origin);
    if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id',String(window.Shopify.theme.id));
    const link = el('a','swym-notification-action',t.view); link.href=url.href; card.append(link); toast.append(card); host().append(toast);
    let announcer=document.getElementById('dac-native-wishlist-announcer');
    if(!announcer){announcer=el('p','dac-native-wishlist-announcer');announcer.id='dac-native-wishlist-announcer';announcer.setAttribute('aria-live','polite');announcer.setAttribute('aria-atomic','true');document.body.append(announcer);}
    announcer.textContent=''; queueMicrotask(()=>{announcer.textContent=message+(product.dt?' '+normalize(product.dt):'');});
    const arm=()=>{clearTimeout(toastTimer);toastTimer=setTimeout(clearToast,7000);};
    toast.addEventListener('pointerenter',()=>clearTimeout(toastTimer));toast.addEventListener('pointerleave',arm);
    toast.addEventListener('focusin',()=>clearTimeout(toastTimer));toast.addEventListener('focusout',arm);arm();
  }
  async function renderShared(container,options = {}) {
    if (!container) return;
    const reference = typeof options === 'string' ? {lid:options} : options.hkey || options.sharedHkey ? {hkey:options.hkey || options.sharedHkey} : {lid:options.lid};
    const pass=(sharedPasses.get(container)||0)+1;sharedPasses.set(container,pass);
    const message=el('p','dac-native-shared-status',t.loading);message.setAttribute('role','status');container.replaceChildren(message);
    try {
      await window.DACWishlist.ready;
      const data=await window.DACWishlist.shared(reference);
      if(sharedPasses.get(container)!==pass)return;
      if(!Array.isArray(data?.items)||!data.list)throw new Error('shared');
      const title=el('h2','swym-wishlist-main-title',normalize(data.list.lname)||t.shared);
      const titleScope=el('div');titleScope.id='swym-wishlist-render-container';
      const titleBar=el('header','swym-wishlist-container-title-bar swym-wishlist-detail-header');titleBar.append(title);titleScope.append(titleBar);
      if(!data.items.length){container.replaceChildren(titleScope,el('p','dac-native-shared-status',t.empty));return;}
      const grid=el('ul','swym-wishlist-grid');
      grid.hidden=true;
      for(const item of data.items){
        const href=safeURL(item.du);if(!href||!/^\d+$/.test(String(item.epi)))throw new Error('item');
        const original=new URL(href),handle=original.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
        if(!handle)throw new Error('item');
        const url=new URL((config.productRoot||'/products/')+handle,location.origin);url.searchParams.set('variant',String(item.epi));
        if(window.Shopify?.theme?.role==='unpublished')url.searchParams.set('preview_theme_id',String(window.Shopify.theme.id));
        const row=el('li');const link=el('a','swym-wishlist-image-wrapper');link.href=url.href;link.textContent=normalize(item.dt);
        const art=image(item.iu);if(art)link.prepend(art);row.append(link,el('h2','',normalize(item.dt)));grid.append(row);
      }
      container.replaceChildren(titleScope,grid);
    }catch(_){
      if(sharedPasses.get(container)!==pass)return;
      message.textContent=t.loadError;message.setAttribute('role','alert');
      const retry=el('button','',t.retry);retry.type='button';retry.addEventListener('click',()=>renderShared(container,options),{once:true});message.append(retry);container.replaceChildren(message);
    }
  }
  function initBackInStock() {
    document.querySelectorAll('dac-restock-panel .dac-restock-notifications > .swym-dummy').forEach(container=>{
      if(container.querySelector('[data-dac-native-bis]'))return;
      const panel=container.closest('dac-restock-panel');
      const form=el('form','dac-native-bis-form swym-isa-inline-form');form.dataset.dacNativeBis='';
      const header=el('div');header.id='swym-reminder-email-header';
      const title=el('div','swym-title');title.append(el('h2','',panel.dataset.signupTitle));
      header.append(title,el('p','swym-remind-description',panel.dataset.signupBody));
      const fields=el('div','swym-remind-email-inputs');const input=el('input');input.id='swym-remind-email-auth-input';input.type='email';input.name='email';input.required=true;input.maxLength=254;input.autocomplete='email';input.setAttribute('aria-label',panel.dataset.emailLabel);
      const submit=el('button','',t.notify);submit.id='swym-remind-email-auth-button';submit.type='submit';
      const error=el('p','swym-validation-error');error.setAttribute('role','alert');fields.append(input,submit);header.append(fields,error);
      const success=el('div');success.id='swym-remind-me-subscribed-success';success.hidden=true;success.setAttribute('role','status');
      const again=el('button','',panel.dataset.anotherEmail);again.type='button';again.id='remind-me-subscribe-btn';again.hidden=true;
      form.append(header,success,again);container.replaceChildren(form);
      let busy=false;
      again.addEventListener('click',()=>{success.hidden=true;success.replaceChildren();again.hidden=true;header.hidden=false;panel.classList.remove('dac-restock-email-success');input.focus();});
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(busy||!form.reportValidity())return;
        const email=input.value.trim();if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)||email.length>254){input.setAttribute('aria-invalid','true');input.reportValidity();return;}
        let product;
        try{product=currentProduct(window.DACWishlist.currentProduct?.() || window.SwymProductVariants?.[window.SwymProductInfo?.currentVariant] || window.SwymPageData);}catch(_){error.textContent=t.subscribeError;return;}
        const version=generation;busy=true;submit.disabled=true;submit.textContent=t.submitting;error.textContent='';input.removeAttribute('aria-invalid');
        try{
          await window.DACWishlist.ready;if(version!==generation)throw new Error('changed');
          await window.DACWishlist.subscribe({event:product,mediums:[{medium:'email',mediumvalue:email}],topics:['backinstock']});
          if(version!==generation)throw new Error('changed');
          window.DACRestockAlerts?.refresh().catch(()=>{});
          if(String(window.DACWishlist.currentProduct?.()?.epi || window.SwymProductInfo?.currentVariant || window.SwymPageData?.epi)!==String(product.epi))return;
          const message=el('div','swym-success-msg');message.append(el('strong','dac-restock-success-title',panel.dataset.successTitle),el('span','dac-restock-success-body',panel.dataset.successBody));
          success.replaceChildren(message);success.hidden=false;again.hidden=false;header.hidden=true;panel.classList.add('dac-restock-email-success');
        }catch(_){error.textContent=t.subscribeError;}
        finally{busy=false;submit.disabled=false;submit.textContent=t.notify;}
      });
      panel.enhance?.();
    });
  }
  let syncNotice, syncBusy=false, syncScope='default';
  const syncDismissed=new Set(),syncDismissKey='dac-wishlist-sync-dismissed-v1';
  try{for(const scope of JSON.parse(sessionStorage.getItem(syncDismissKey)||'[]'))if(typeof scope==='string')syncDismissed.add(scope);}catch(_){}
  function saveSyncDismissal(){try{sessionStorage.setItem(syncDismissKey,JSON.stringify([...syncDismissed]));}catch(_){}}
  function showSyncStatus(pending,scope=window.DACWishlist?.sessionStatus?.syncScope||'default') {
    if(scope!==syncScope){syncNotice?.remove();syncNotice=null;syncScope=scope;}
    if (!pending) {syncNotice?.remove();syncNotice=null;syncDismissed.delete(scope);saveSyncDismissal();return;}
    const query=new URLSearchParams(location.search),shared=query.has('hkey')||query.get('shared')==='1';
    const library=shared?null:document.querySelector('.dac-wishlist-page');
    if(syncDismissed.has(scope)&&!library)return;
    if (syncNotice) return;
    syncNotice=el('aside','dac-native-sync-status');syncNotice.setAttribute('role','status');
    const notice=syncNotice,message=el('p','',t.syncPending),retry=el('button','dac-native-sync-retry',t.syncRetry);retry.type='button';notice.append(message,retry);
    const close=closeButton(()=>{syncDismissed.add(scope);saveSyncDismissal();notice.remove();if(syncNotice===notice)syncNotice=null;});
    close.classList.add('dac-native-sync-close');notice.append(close);
    if(library){notice.classList.add('dac-native-sync-inline');library.prepend(notice);}else document.body.append(notice);
    retry.addEventListener('click',async()=>{
      if(syncBusy)return;syncBusy=true;retry.disabled=true;retry.textContent=t.syncing;
      try{await window.DACWishlist.retrySync();if(syncScope!==scope)return;if(!window.DACWishlist.sessionStatus?.mergePending){showSyncStatus(false,scope);return;}message.textContent=t.syncError;}
      catch(_){message.textContent=t.syncError;}
      finally{syncBusy=false;retry.disabled=false;retry.textContent=t.syncRetry;}
    });
  }
  document.addEventListener('dac:wishlist-sync-pending',event=>showSyncStatus(event.detail?.pending===true,event.detail?.scope));
  if(window.DACWishlist?.sessionStatus?.mergePending===true)showSyncStatus(true);
  window.DACWishlistUI={openPicker,notify,renderShared,initBackInStock,confirmSaved};
  (window.SwymCallbacks=window.SwymCallbacks||[]).push(sdk=>{
    const changed=()=>{generation++;dismiss(active,false);clearToast();};
    for(const name of ['customerInfoRefreshed','regidRefreshed'])if(sdk.JSEvents?.[name])sdk.evtLayer?.addEventListener(sdk.JSEvents[name],changed);
    initBackInStock();
  });
  window.addEventListener('pagehide',()=>{generation++;dismiss(active,false);clearToast();});
})();
